import { Fragment } from 'react';
import { Grid } from '@mui/material';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';

interface CohabitatonDetailPageButtonsProps {
  stepState: number;
  handleStep: (step: number) => void;
}

const CohabitatonDetailPageButtons = ({
  stepState,
  handleStep,
}: CohabitatonDetailPageButtonsProps): React.ReactElement => {
  return (
    <Fragment>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={12}>
          <StepButton
            variant="outlined"
            active={stepState === 0}
            fullWidth
            color="cdmBrandThird"
            onClick={() => handleStep(0)}
          >
            <StepTypography active={stepState === 0}>Convivenza</StepTypography>
          </StepButton>
        </Grid>
      </Grid>
    </Fragment>
  );
};

CohabitatonDetailPageButtons.displayName = 'Cohabitation Detail buttons page component';

export default CohabitatonDetailPageButtons;
